var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1328 25H9.17969C8.2104 25 7.42188 24.2115 7.42188 23.2422V11.1328C7.42188 10.1635 8.2104 9.375 9.17969 9.375H11.1328C12.1021 9.375 12.8906 10.1635 12.8906 11.1328V23.2422C12.8906 24.2115 12.102 25 11.1328 25Z",
    fill: "#FF82AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71094 25H1.75782C0.788527 25 0 24.2115 0 23.2422V15.0391C0 14.0698 0.788527 13.2812 1.75782 13.2812H3.71094C4.68023 13.2812 5.46876 14.0698 5.46876 15.0391V23.2422C5.46876 24.2115 4.68018 25 3.71094 25Z",
    fill: "#FF82AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5549 25H16.6018C15.6325 25 14.844 24.2115 14.844 23.2422V7.03125H13.7707C13.269 7.03125 12.827 6.74805 12.6173 6.29219C12.4077 5.83633 12.4803 5.3165 12.8068 4.9355C12.8105 4.93115 12.8143 4.92681 12.8181 4.92256L16.9965 0.259863C17.1447 0.0944824 17.3563 0 17.5784 0C17.8004 0 18.012 0.0944824 18.1602 0.259863L22.3386 4.92256C22.3424 4.92681 22.3462 4.93115 22.3499 4.9355C22.6765 5.31646 22.7491 5.83633 22.5394 6.29219C22.3297 6.74805 21.8877 7.03125 21.386 7.03125H20.3127V23.2422C20.3127 24.2115 19.5242 25 18.5549 25Z",
    fill: "#FF82AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvests);
export default __webpack_public_path__ + "static/media/invests.be0627b287582d06b941f774b1b9663e.svg";
export { ForwardRef as ReactComponent };